import { _t, hideParentBanner } from '../base'

export function createInstagramFeed() {
    const title = _t('instagram.title')

    if ($('.custom-footer__instagram').length) {
        const template = /* HTML */ `
            <div class="ig">
                <div class="container">
                    <div class="h4 homepage-group-title">${title}</div>
                    <div class="instagram-wrap"></div>
                </div>
            </div>
        `

        $(template).insertBefore('#footer')

        if ($('.instagram-widget > a').length) {
            $('.instagram-widget > a').each(function () {
                const href = $(this).attr('href')
                const imgSrc = $(this).find('img').attr('data-src')
                $('.instagram-wrap').append(/* HTML */ `
                    <div class="igfeed">
                        <a href="${href}" target="_blank" style="background-image: url(${imgSrc})"></a>
                    </div>
                `)
            })
        } else {
            const sampleProducts = [
                { id: 1, name: 'Lipstick' },
                { id: 2, name: 'Face Cream' },
                { id: 3, name: 'Mascara' },
                { id: 4, name: 'Nail Polish' },
                { id: 5, name: 'Eyeshadow Palette' },
                { id: 6, name: 'Blush' },
            ]

            sampleProducts.forEach(({ id, name }) => {
                const href = `https://example.com/product/${id}`
                const imgSrc = `https://picsum.photos/seed/${id}/300/300`
                $('.instagram-wrap').append(/* HTML */ `
                    <div class="igfeed">
                        <a
                            href="${href}"
                            target="_blank"
                            style="background-image: url(${imgSrc})"
                            title="${name}"></a>
                    </div>
                `)
            })
        }
    }
}
